<template>
	<div class="minicart d-flex">
		<i class="lnr icon-cart cart"></i>
		<span class="title d-none d-xl-inline">{{__('shopping_cart')}}</span>
		<span class="amount ms-1">{{$store.state.cart.items_quantity}}</span>
	</div>
</template>

<script>
export default {
	name: "Minicart",
}
</script>